const principal_investigator = [
  {
    name: "Prof. Jiaxuan You",
    img: require("../assets/people/JiaxuanYou.jpg"),
    link: "https://cs.stanford.edu/~jiaxuan/",
  },
];

const phd_students = [
  {
    name: "Tao Feng",
    img: require("../assets/people/Tao Feng.jpg"),
    link: "https://ft2023.github.io/taofeng.github.io/",
  },
  {
    name: "Yanru Qu",
    img: require("../assets/people/YanruQu.jpg"),
    description: "Coadvised w/ [Prof. Ge Liu](https://www.mit.edu/~geliu/)",
  },
  {
    name: "Peixuan Han",
    img: require("../assets/people/PeixuanHan.jpg"),
     link: "https://hanpx20.github.io/",
  },
  {
    name: "Haofei Yu",
    img: require("../assets/people/HaofeiYu.jpg"),
    link: "https://haofeiyu.me",
  },
  {
    name: "Siqi Zhu",
    link: "https://zhusq20.github.io/",
  },
];

const ms_students = [
  {
    name: "Zhaochen Hong",
    img: require("../assets/people/ZhaochenHong.jpeg"),
    link: "https://zhaochenhong42.github.io/",
  },
  {
    name: "Yexin Wu",
    img: require("../assets/people/YexinWu.jpg"),
    link: "https://librowu.github.io/",
  },
  {
    name: "Jinwei Yao",
    img: require("../assets/people/JinweiYao.jpg"),
    link: "https://kivi-yao.github.io/",
  },
  {
    name: "Yihang Sun",
    img: require("../assets/people/YihangSun.jpg"),
    link: "https://plotbaelish.github.io/",
  },
  {
    name: "Hongyi Du",
    img: require("../assets/people/HongyiDu.jpg"),
    link: "https://hongyi-du.github.io/",
  },
];

const visiting_students = [
  {
    name: "Matteo Boffa",
    img: require("../assets/people/MatteoBoffa.jpeg"),
    description:
      "Ph.D. student  \nfrom [Politecnico di Torino](https://www.polito.it/)",
  },
  {
    name: "Zijia Liu",
    img: require("../assets/people/ZijiaLiu.jpeg"),
    link: "https://m-serious.github.io/",
    description: "Ph.D. student",
  },
];

const alumni = [
  {
    name: "Kunlun Zhu",
    link: "https://kunlun-zhu.github.io/",
    description: "Computer Science Ph.D. student at UIUC",
  },
  {
    name: "Yihang Sun",
    description: "Undergraduate at Peking University",
  },
  {
    name: "Guanyu Lin",
    link: "https://guanyu-lin.github.io/",
    description: "Ph.D student at Carnegie Mellon University",
    placement: "",
  },
];

export {
  principal_investigator,
  phd_students,
  ms_students,
  visiting_students,
  alumni,
};
